<ion-header collapse="fade" [translucent]="false" class="ion-no-border">
    <ion-toolbar>
        <div class="header-layout">
            <div class="header-layout_title" [class]="enableTitle ? 'center' : ''">
                <ion-icon *ngIf="enableLogo"
                    expand="block"
                    class="logo"
                    src="assets/Vessel_logo.svg"
                    alt="logo">
                </ion-icon>

                <div *ngIf="enableTitle" class="page-title">
                    {{titleText}}
                </div>
            </div>
            <div class="header-layout_button">
                <ion-icon
                    *ngIf="isHomePage && !enableBack"
                    (click)="openSettings()"
                    class="circle-btn"
                    src="assets/settings_icon.svg"
                    alt="settings button">
                </ion-icon>

                <ion-back-button class="back-btn"
                        *ngIf="isSettingsPage && !enableBack"
                        text=""
                        icon="assets/home_icon.svg"
                        class="circle-btn circle-btn_fix-align"
                        [defaultHref]="defaultLink">
                </ion-back-button>

                <ion-icon *ngIf="enableClearBtn"
                    (click)="clearBtn.emit()"
                    class="circle-btn"
                    name="refresh-outline"
                    alt="clear chat button">
                </ion-icon>

                <ion-icon *ngIf="goToSettings"
                    (click)="openSettings()"
                    class="circle-btn"
                    src="assets/settings_icon.svg"
                    alt="settings button">
                </ion-icon>

                <ion-icon *ngIf="goToDashboard"
                    (click)="openDashboard()"
                    class="circle-btn"
                    src="assets/home_icon.svg"
                    alt="dashboard button">
                </ion-icon>

                <ion-back-button class="back-btn"
                         *ngIf="enableBack"
                         text=""
                         icon="assets/dropdown_arrow.svg"
                         class="arrow-btn"
                         [defaultHref]="defaultLink">
                </ion-back-button>
            </div>
        </div>
        <div class="header-layout_fade"></div>


        <ion-icon size="large"
                  *ngIf="enableMenu"
                  class="menu-btn"
                  slot="start"
                  (click)="openMenu()"
                  name="ellipsis-horizontal">
        </ion-icon>

        <ion-button slot="start"
                    class="save-btn"
                    *ngIf="enableSaveBtn"
                    (click)="saveBtn.emit()"
                    fill="clear">{{saveTitle}}
        </ion-button>
    </ion-toolbar>
</ion-header>

<!-- TODO: remove after redesigning Settings tab -->
<ion-menu *ngIf="enableMenu"
          menuId="menuId"
          side="end"
          auto-hide="true"
          contentId="main-content">
    <ion-header>
        <ion-toolbar>
            <ion-title>{{menuTitle}}</ion-title>
        </ion-toolbar>
    </ion-header>

    <ion-content>
        <ion-menu-toggle auto-hide="true">
        <ion-list *ngFor="let option of menuOptions">
            <ion-item button
                      (click)="option.func()">
                <ion-label>{{option.title}}</ion-label>
            </ion-item>
        </ion-list>
    </ion-menu-toggle>
    </ion-content>
</ion-menu>
